<template>
  <div>
    <v-app-bar top app short>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="d-md-none" />
      <v-btn text class="mx-1 d-none d-md-flex" to="/">
        <v-icon small class="mx-1">
          mdi-filter-outline
        </v-icon>
        Vyhledávání
      </v-btn>
      <v-chip outlined color="orange" class="mx-2 d-sm-none d-md-block" v-if="!isNotLink">
        <v-icon class="mx-1">mdi-alert-outline</v-icon>
        Nacházíte se v režimu prohlížení jako host
      </v-chip>
      <v-menu transition="scroll-y-transition" v-if="canEditCodebooks">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text class="d-none d-md-flex"
            v-bind="attrs"
            v-on="on">
            <v-icon small class="mx-1">
              mdi-file-multiple-outline
            </v-icon>
            Číselníky
          </v-btn>
        </template>
        <v-list nav min-width="250">
          <v-list-item to="/Authors">
            <v-list-item-icon>
              <v-icon small>mdi-account-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Autoři</v-list-item-content>
          </v-list-item>
          <v-list-item to="/ArtworkTypes">
            <v-list-item-icon>
              <v-icon small>mdi-image-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Typy</v-list-item-content>
          </v-list-item>
          <v-list-item to="/Locations">
            <v-list-item-icon>
              <v-icon small>mdi-map-marker-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Lokace</v-list-item-content>
          </v-list-item>
          <v-list-item to="/Styles">
            <v-list-item-icon>
              <v-icon small>mdi-palette-swatch-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Styly</v-list-item-content>
          </v-list-item>
          <v-list-item to="/Techniques">
            <v-list-item-icon>
              <v-icon small>mdi-brush-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Techniky</v-list-item-content>
          </v-list-item>
          <v-list-item to="/Materials">
            <v-list-item-icon>
              <v-icon small>mdi-receipt-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Materiály</v-list-item-content>
          </v-list-item>
          <v-list-item to="/Themes">
            <v-list-item-icon>
              <v-icon small>mdi-shape-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Témata</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn text class="mx-1 d-none d-md-flex" to="/ShareLinks" v-if="canShare">
        <v-icon small class="mx-1">
          mdi-share-outline
        </v-icon>
        Sdílení
      </v-btn>
      <v-spacer />
      <nav-collection class="d-none d-md-flex">
      </nav-collection>
      <nav-export-box>
      </nav-export-box>
      <v-menu
        offset-y
        bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on">
            <v-avatar
              color="accent"
              size="40">
              {{ userInitials }}
            </v-avatar>
          </v-btn>
        </template>
        <v-list nav min-width="250">
          <v-list-item to="/MyProfile" v-if="isNotLink">
            <v-list-item-icon>
              <v-icon small>mdi-account-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $t('navigation.my_profile') }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/LocalSettings" v-if="isNotLink">
            <v-list-item-icon>
              <v-icon small>mdi-wrench-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $t('navigation.local_settings') }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/PasswordChange" v-if="isNotLink">
            <v-list-item-icon>
              <v-icon small>mdi-key-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $t('navigation.password_change') }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/Export/BoxList" v-if="isNotLink">
            <v-list-item-icon>
              <v-icon small>mdi-archive-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $t('navigation.box_list') }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/Export/History" v-if="isNotLink">
            <v-list-item-icon>
              <v-icon small>mdi-export</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $t('navigation.export_history') }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-btn outlined color="error" @click="logout">
                {{ $t('navigation.logout') }}
              </v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer absolute temporary v-model="drawer">
      <v-list nav min-width="250">
        <v-subheader>
          Hlavní menu
        </v-subheader>
        <v-list-item-group>
          <v-list-item to="/">
            <v-list-item-icon>
              <v-icon small>mdi-filter-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              Vyhledávání
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/ShareLinks" v-if="canShare">
            <v-list-item-icon>
              <v-icon small>mdi-share-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              Sdílení
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-subheader>
          Kolekce
        </v-subheader>
        <nav-collection class="d-flex justify-start my-2 mx-2">
        </nav-collection>
        <v-subheader v-if="canEditCodebooks">
          Číselníky
        </v-subheader>
        <v-list-item-group v-if="canEditCodebooks">
          <v-list-item to="/Authors">
            <v-list-item-icon>
              <v-icon small>mdi-account-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Autoři</v-list-item-content>
          </v-list-item>
          <v-list-item to="/ArtworkTypes">
            <v-list-item-icon>
              <v-icon small>mdi-image-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Typy</v-list-item-content>
          </v-list-item>
          <v-list-item to="/Locations">
            <v-list-item-icon>
              <v-icon small>mdi-map-marker-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Lokace</v-list-item-content>
          </v-list-item>
          <v-list-item to="/Styles">
            <v-list-item-icon>
              <v-icon small>mdi-palette-swatch-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Styly</v-list-item-content>
          </v-list-item>
          <v-list-item to="/Techniques">
            <v-list-item-icon>
              <v-icon small>mdi-brush-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Techniky</v-list-item-content>
          </v-list-item>
          <v-list-item to="/Materials">
            <v-list-item-icon>
              <v-icon small>mdi-receipt-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Materiály</v-list-item-content>
          </v-list-item>
          <v-list-item to="/Themes">
            <v-list-item-icon>
              <v-icon small>mdi-shape-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Témata</v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import NavExportBox from '@/components/exportBox/NavExportBox'
import NavCollection from '@/components/collection/NavCollection'

export default {
  components: { NavExportBox, NavCollection },
  name: 'MainNav',
  data: () => ({
    drawer: false
  }),
  methods: {
    logout () {
      this.$store.dispatch('authentication/logout')
      this.$router.push('/Login')
    }
  },
  computed: {
    isNotLink () {
      return this.$store.getters['authentication/accessType'] > 1
    },
    canShare () {
      return this.$store.getters['authentication/accessType'] > 1
    },
    userInitials () {
      return this.$store.state.basicUserInfo.initials
    },
    currentExportBoxId () {
      return this.$store.getters['exportBoxes/currentExportBoxId']
    },
    canEditCodebooks () {
      return this.$store.getters['basicUserInfo/canEditCodebooks']
    },
    hasAnyCollection () {
      return this.$store.getters['basicUserInfo/hasAnyCollection']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MainNav.vue